import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from './apiClient';

// Fetch ICT Cost records by ICT id
export const fetchIctCostByIctId = createAsyncThunk(
  'ictCost/fetchByIctId',
  async (ictid, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/ictCost/?ictid=${ictid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Insert a new ICT Cost record
export const insertIctCost = createAsyncThunk(
  'ictCost/insert',
  async (ictCost, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(`/ictCost/`, ictCost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update an existing ICT Cost record
export const updateIctCost = createAsyncThunk(
  'ictCost/update',
  async (ictCost, { rejectWithValue }) => {
    try {
      const response = await apiClient.put(`/ictCost/${ictCost.id}/`, ictCost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Delete an ICT Cost record
export const deleteIctCost = createAsyncThunk(
  'ictCost/delete',
  async (id, { rejectWithValue }) => {
    try {
      await apiClient.delete(`/ictCost/${id}/`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const ictCostSlice = createSlice({
  name: 'ictCost',
  initialState: {
    ictCosts: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIctCostByIctId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIctCostByIctId.fulfilled, (state, action) => {
        state.loading = false;
        state.ictCosts = action.payload;
      })
      .addCase(fetchIctCostByIctId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(insertIctCost.fulfilled, (state, action) => {
        state.ictCosts.push(action.payload);
      })
      .addCase(insertIctCost.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateIctCost.fulfilled, (state, action) => {
        const index = state.ictCosts.findIndex((cost) => cost.id === action.payload.id);
        if (index !== -1) {
          state.ictCosts[index] = action.payload;
        }
      })
      .addCase(updateIctCost.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteIctCost.fulfilled, (state, action) => {
        state.ictCosts = state.ictCosts.filter((cost) => cost.id !== action.payload);
      })
      .addCase(deleteIctCost.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default ictCostSlice.reducer;
